import * as _ from "lodash";

let admin = (state = { firebaseToken: null, superSecret: null, superToken: null }, action) => {
    let index = -1
    let name = "BILL"
    switch (action.type) {
        case "LOGIN":
            state = action.payload
            break
        case "LOGOUT":
            state = {}
    }
    return state;
};


export default admin


// WEBPACK FOOTER //
// ./src/reducer/admin.js